import { render, staticRenderFns } from "./ListOffersComparison.vue?vue&type=template&id=5615acd0&scoped=true"
import script from "./ListOffersComparison.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListOffersComparison.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListOffersComparison.vue?vue&type=style&index=0&id=5615acd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5615acd0",
  null
  
)

export default component.exports